import * as React from "react";

function BarIcon(props) {
	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				width="1em"
				height="1em"
				{...props}
			>
				<path
					fill="currentColor"
					fillRule="evenodd"
					d="M8.755 2.308A4 4 0 0 0 5.46 6.733l.017.14a1 1 0 0 0 .992.879h1.764L5.267 21.595a.75.75 0 0 0 1.467.314l.944-4.407h8.644l.945 4.407a.75.75 0 0 0 1.467-.314L15.766 7.752h1.764a1 1 0 0 0 .993-.88l.017-.139a4 4 0 0 0-3.295-4.425l-.373-.064a17 17 0 0 0-5.745 0zm5.495 5.444h-4.5a1 1 0 0 1-.016.157l-1.735 8.093h8.002l-1.734-8.093a1 1 0 0 1-.017-.157"
					clipRule="evenodd"
				></path>
			</svg>
		</>
	);
}

export default BarIcon;
